export default "__VITE_ASSET__Ccepv$4H__"